export default __webpack_public_path__ + "static/media/Investigation.46bcae66.svg";